import React from 'react';
import PropTypes from 'prop-types';
// import SVGInline from 'react-svg-inline'
import { getInstrumentIcon } from "../../../../utils";

// components

// svgs
// import clockSVG from '../../../inlineSVGs/clockSVG';

// styles
import './Instruments.css';

const Instruments = ({ instruments, wrapperStyle }) => {

    const renderInstruments = () => {

        return instruments.map((instrument, i) => {
            return (
                <img key={`instrument-modal-${i}`}
                     className="instrument"
                     src={getInstrumentIcon(instrument, true)}
                     alt="instruments"
                />
            )
        })
    };

    return (
        <div className="modal-instruments-wrapper" style={wrapperStyle}>
            {renderInstruments()}
        </div>
    )
};

Instruments.propTypes = {
    instruments: PropTypes.array,
    wrapperStyle: PropTypes.object
};

export default Instruments;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/Instruments/Instruments.js